import { render, staticRenderFns } from "./BookingReplaceTalentModal.vue?vue&type=template&id=52e0c938"
import script from "./BookingReplaceTalentModal.vue?vue&type=script&lang=js"
export * from "./BookingReplaceTalentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports